import { type FC } from 'react';

// MUI
import Box from '@mui/material/Box';
import Typography, { type TypographyOwnProps } from '@mui/material/Typography';

// common
import { MEDIUM_FONT_SIZE } from 'modules/map/components/pdf-print-form/utils';

interface StyledSignatureBlockProps {
  value: string;
  typographySx?: TypographyOwnProps;
}

const StyledSignatureBlock: FC<StyledSignatureBlockProps> = (props) => {
  const { value, typographySx } = props;

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: MEDIUM_FONT_SIZE,
          fontStyle: 'italic',
          textAlign: 'center',
          ...typographySx,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default StyledSignatureBlock;
